<template>
<div>
  <div  v-if="loading">
  <hollow-dots-spinner
  class="loading_card_spinner"
          :animation-duration="1000"
          :dot-size="35"
          :dots-num="3"
          color="var(--primary-color)"
        />
     
</div>
        <!-- Start Hero -->
        <section v-else class="page_title relative table w-full py-20 lg:py-24 bg-gray-50 dark:bg-slate-800">
            <div class="container relative">
                <div class="grid grid-cols-1 mt-14">
                    <h3 class="text-3xl leading-normal font-semibold">{{$t('Checkout')}}</h3>
                </div><!--end grid-->

                <div class="relative mt-3">
                    <ul class="tracking-[0.5px] mb-0 inline-block">
                        <li class="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500">
                            <router-link to="/home">{{$t('home')}}</router-link></li>
                        <li class="inline-block text-base text-slate-950 dark:text-white mx-0.5
                         ltr:rotate-0 rtl:rotate-180">
                         <i class="mdi mdi-chevron-right"></i></li>
                        <li class="inline-block uppercase text-[13px] font-bold text-orange-500" 
                        aria-current="page">{{$t('Checkout')}}</li>
                    </ul>
                </div>
            </div><!--end container-->
        </section><!--end section-->
        <!-- End Hero -->

        <!-- Start -->
        <section 
        v-if="items.length != 0"
        class="relative md:py-24 py-16">
            <div class="container relative">
                <div class="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 gap-6 checkout_page">
                    <div class="lg:col-span-8">
                        <div class="p-6 rounded-md shadow dark:shadow-gray-800">
                            <h3 class="text-xl leading-normal font-semibold">{{$t('Billing Details')}}</h3>

                            <form>
                                <div class="grid lg:grid-cols-12 grid-cols-1 mt-6 gap-5">
                                    <div class="lg:col-span-6">
                                        <label class="form-label font-semibold">{{ $t('name') }}: <span class="text-red-600">*</span></label>
                                        <input
                                         type="text" 
                                         class="w-full py-2 
                                         px-3 h-10 bg-transparent 
                                         dark:bg-slate-900 dark:text-slate-200 
                                         rounded outline-none border border-gray-100 
                                         dark:border-gray-800 focus:ring-0 mt-2" 
                                         placeholder="First Name:" id="firstname" 
                                         name="name" 
                                         :value="name" readonly>
                                        </div>
                                   

                            

                                    <div class="lg:col-span-6">
                                        <label class="form-label font-semibold">{{$t('Email')}}: <span class="text-red-600">*</span></label>
                                        <input type="email"
                                         class="w-full py-2 px-3 h-10 
                                         bg-transparent dark:bg-slate-900
                                          dark:text-slate-200 rounded
                                           outline-none border border-gray-100
                                            dark:border-gray-800 focus:ring-0 mt-2"
                                             placeholder="Email" name="email" :value="email" readonly>
                                    </div>

                                    <div class="lg:col-span-6">
                                        <label class="form-label font-semibold">{{$t('Phone')}}: <span class="text-red-600">*</span></label>
                                        <input type="text"
                                         class=" phone_input w-full py-2 px-3 h-10 
                                         bg-transparent dark:bg-slate-900
                                          dark:text-slate-200 rounded
                                           outline-none border border-gray-100
                                            dark:border-gray-800 focus:ring-0 mt-2"
                                             placeholder="phone" 
                                             name="phone"
                                              :value="phone"
                                               readonly dir="ltr"
                                               >
                                    </div>

                                  </div>

                                    <!-- gift form -->
                <div v-if="$store.state.gift_orders==1">
                  <label class='is_gift'>
                    <input type="checkbox" @change="funIsGift()" />
                    {{ $t('is_gift_order') }}
                  </label>
                  <form id="gift" v-if="(gift.is_gift == 1)&&($store.state.gift_orders==1)">
                    <div class="grid lg:grid-cols-12 grid-cols-1 mt-6 gap-5">

                      <div class="lg:col-span-6">
                        <label class="form-label font-semibold">{{ $t('reciver name') }}: <span
                            class="text-red-600">*</span></label>
                        <input type="text" class="w-full py-2 
                                         px-3 h-10 bg-transparent 
                                         dark:bg-slate-900 dark:text-slate-200 
                                         rounded outline-none border border-gray-100 
                                         dark:border-gray-800 focus:ring-0 mt-2" :placeholder="$t('name')"
                          minlength="3" maxlength="255" name="name" v-model="gift.receiver" id="name">
                      </div>
                      <div class="lg:col-span-6">
                        <label class="form-label font-semibold">{{ $t('reciver phone') }}: <span
                            class="text-red-600">*</span></label>
                        <input type="text" class=" phone_input w-full py-2 px-3 h-10 
                                         bg-transparent dark:bg-slate-900
                                          dark:text-slate-200 rounded
                                           outline-none border border-gray-100
                                            dark:border-gray-800 focus:ring-0 mt-2" 
                          placeholder="phone" name="phone"
                          v-model="gift.phone" dir="ltr" required 
                          :minlength=$store.state.country_length
                          :maxlength=$store.state.country_length 
                          style="text-align:center" id="phone">
                        <span class="flag">
                          <h2>{{ $store.state.country_code }}</h2>
                          <img :src="this.$store.state.country_flag" />


                        </span>

                      </div>

                      <div class="lg:col-span-6">
                        <label class="form-label font-semibold">{{ $t('gift text') }}: <span
                            class="text-red-600"></span></label>
                        <textarea class="w-full py-2 
                                         px-3  bg-transparent 
                                         dark:bg-slate-900 dark:text-slate-200 
                                         rounded outline-none border border-gray-100 
                                         dark:border-gray-800 focus:ring-0 mt-2" :placeholder="$t('gift text')"
                          v-model="gift.message" id="gift_text" rows="3"></textarea>
                      </div>

                    </div>
                  </form>
                </div>
                <!--  -->
                                          
                                  <div v-if="loadingMethods" class="empty text-center center-text">
                 
                                  <img src="https://etrolley.net/pet_shop/assets/images/ajax-loader.gif"/>
                                   <br>

                                   </div>
                                   
                                   
                              
                            </form>

                            <h3 class="text-xl leading-normal font-semibold mt-6">{{$t('DeliveryMethod')}}</h3>

                            <form action="">
                                <form v-if="gift.is_gift == 0">
                                    <div class="grid lg:grid-cols-12 grid-cols-1 mt-6 gap-5">
                                        <div class="lg:col-span-12">
                                            
    
                                            <div
                                             v-for="(item, index) in this.DBitems.delivery_type.types"
                                            :key="index"
                                            class="block mt-2">
                                                <div>
                                                    <label 
                                                    :for="'delivery'+item.id"
                                                    class="inline-flex items-center">
                                                        <input 
                                                        type="radio"
                                 name="delivery_option" 
                                :id="'delivery'+item.id" 
                                :value="item.id" 
                                @click="selectDeliveryTypeId(item.id)"
                                                        class="
                                                        border-gray-100 dark:border-gray-800
                                                         text-orange-500 
                                                          me-2" 
                                                          >
                                                        <span class="text-slate-400">{{ item.type }}</span>
                                                    </label>
                                                </div>
                                            </div>


                                        </div>

                                        

                                    </div>
                                </form>
                                     <div v-if="selectDeliveryType==5">
                   <!--  -->
                  <div>
                    <label class="inline-flex items-center">
                      <input @click="is_delivery_later=0" type="radio" class="border-gray-100 
                                                        dark:border-gray-800 text-orange-500 
                                                        
                       me-2" name="delivery_later" :value="is_delivery_now">
                      <span class="text-slate-400">{{ $t('delivery now') }}</span>
                    </label>
                  </div>
                    <div>
                    <label class="inline-flex items-center">
                      <input @click="is_delivery_later=1" type="radio" class="border-gray-100 
                                                        dark:border-gray-800 text-orange-500 
                                                        
                                                           me-2" name="delivery_later" :value="is_delivery_later">
                      <span class="text-slate-400">{{ $t('delivery later') }}</span>
                    </label>
                  </div>
                </div>
               <!--  -->
                  <!-- is_delivery later -->
                  <div v-if="is_delivery_later==1" class="grid lg:grid-cols-12 grid-cols-1 gap-5" id="delivery_later">

                    <div class="lg:col-span-6">
                      <div class="mb-4">
                        <label class="font-semibold" for="delivery_date">
                          {{ $t('delivery date') }} :</label>
                        <input type="date" id="delivery_date" class="mt-3 w-full py-2
                                             px-3 h-10 bg-transparent 
                                             dark:bg-slate-900 dark:text-slate-200 
                                             rounded outline-none border border-gray-100 
                                             dark:border-gray-800 focus:ring-0" 
                          format="YYYY-MM-DD"
                          value-type="format"
                          v-model="delivery_date"
                          :placeholder="$t('select date')" 
                          @change="checkClosedDays"
                          :min="today"
                          />
                      </div>
                    </div>
                    <div class="lg:col-span-6">
                      <div class="mb-4">
                        <label class="font-semibold" for="delivery_time">
                          {{ $t('delivery time') }} :</label>
                        <input class="mt-3 w-full py-2
                                             px-3 h-10 bg-transparent 
                                             dark:bg-slate-900 dark:text-slate-200 
                                             rounded outline-none border border-gray-100 
                                             dark:border-gray-800 focus:ring-0" type="time" 
                                             v-model="delivery_time"
                                             :min="minTime"
                                             :max="maxTime"
                          id="delivery_time">
                      </div>
                    </div>

                  </div>
                                <div v-if="showAddress" class="lg:col-span-4">
                                     
                                     <label class="font-semibold">{{ $t('selectAddress') }}:</label>
                                     <select 
                                     class="form-select form-input mt-2 
                                     w-full py-2 px-3 h-10 bg-transparent 
                                     dark:bg-slate-900 dark:text-slate-200 
                                     rounded outline-none border border-gray-100 
                                     dark:border-gray-800 focus:ring-0"
                                     id="addressSelect"
                                     :title="$t('Address')"
                                     v-if="addresses.length != 0"
                                    @change="onChange($event)"
                                     >
                                     <option hidden selected value="SelectOne">
                                     {{ $t("SelectOne") }}
                                     </option>
                                      <option
                                       v-for="(item, index) in addresses"
                                      :key="index"
                                      :value="item.id"
                                          >
                                      {{ item.title }}
                                     </option>
                                     </select>
                                     <div>
                                       <br>
                                      <button 
                                      type="button"
                                   class="py-2 px-5 inline-block 
                              tracking-wide align-middle 
                              duration-500 text-base text-center 
                              text-white rounded-md w-full btn_add_address"

                @click="open_address">
                 {{ $t("AddNewAddress") }}
               </button>
               <br>
               <vodal
               class="add_address_order"
                 :show="this.$store.state.addAddress"
                 animation="flip"
                 @hide="close_address"
                
               >
                 <div class="add_address" style="overflow: scroll">
                   <add-address></add-address>
                 </div>
               </vodal>
                                      </div>
                                 
                                 </div>
                            </form>


                            <h3 class="text-xl leading-normal font-semibold mt-6">{{$t('PaymentMethod')}}</h3>

                            <form action="">
                                <form>
                                    <div class="grid lg:grid-cols-12 grid-cols-1 mt-6 gap-5">
                                        <div class="lg:col-span-12">
                                            
    
                                            <div
                                             v-for="(item, index) in this.DBitems.payment_types.types"
                                            :key="index"
                                            class="block mt-2">
                                                <div>
                                                    <label class="inline-flex items-center">
                                                        <input 
                                                         @click="selectPaymentTypeId(item.id)" 
                                                         
                                                        type="radio" 
                                                        class="border-gray-100 
                                                        dark:border-gray-800 text-orange-500 
                                                        
                                                           me-2" 
                                                          name="radio_payments"
                                                           :value="item.id">
                                                        <span class="text-slate-400">{{item.type}}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        
    
                                       
                                    </div>
                                </form>
                            </form>
<div class="gift-card-field product_note">
                  <label>{{ $t('note') }}</label>
                  <textarea v-model="allOrderNote" rows="3" class="gift-card-input "></textarea>
                </div>
                            <div class="mt-4">
                                <input type="submit"
                                v-if="!loadingMethods && this.DBitems != null"  
                                 class="py-2 px-5 inline-block 
                                 tracking-wide align-middle 
                                 duration-500 text-base text-center 
                                 bg-orange-500 text-white rounded-md w-full" 
                                 :value="$t('Continue to checkout')"
                                  id="confirm_btn"
                    @click="openConfirmPopup"

                                 >
                            </div>
                        </div>

                    </div><!--end col-->

                    <div class="lg:col-span-4">
                        <div class="p-6 rounded-md shadow dark:shadow-gray-800">
                            <div class="flex justify-between items-center">
                                <h5 class="text-lg font-semibold">{{$t('Your Cart')}}</h5>

                                <a href="javascript:void(0)" 
                                class="bg-orange-500 flex justify-center
                                 items-center text-white text-[10px] 
                                 font-bold px-2.5 py-0.5 rounded-full h-5">
                                 {{ this.items.length }}</a>
                            </div>

                            <div class="mt-4 rounded-md shadow dark:shadow-gray-800">

                              <cart_item  v-for="item in this.items"
                                     :key="item"
                                     :itemId="item"
                                     > 
                                </cart_item>

                                <div class="p-3 flex justify-between items-center">
                                   
                                        <h5 class="font-semibold">{{ $t('subTotal') }}</h5>
                                   

                                    <p class="font-semibold">
                                      {{ (PartialPrice*this.$store.state.rate).toFixed(2) }} {{ this.$store.state.UnitPrice }} 
                                     </p>
                                </div>
                                
                                <div v-if="this.discountPrice!=0" 
                                class="p-3 flex justify-between items-center 
                                border border-gray-100 dark:border-gray-800
                                dark:bg-slate-800 text-green-600">
                                    <div>
                                        <h5 class="font-semibold">{{ $t('discount') }}</h5>
                                        <p class="text-sm text-green-600"v-if="couponType=='percentage'">({{ discountPrice*this.$store.state.rate }} %)</p>
                                        <p v-else class="text-sm text-green-600">({{ discountPrice*this.$store.state.rate }}   {{ this.$store.state.UnitPrice }})</p>

                                      </div>

                                    <p v-if="couponType=='percentage'" class="text-green-600 font-semibold">
                                      -{{ ((this.discountPrice * this.PartialPrice*this.$store.state.rate) / 100).toFixed(2) }}

                                        {{ this.$store.state.UnitPrice }}</p>

                                        <p v-else class="text-green-600 font-semibold">
                                      -{{ (this.discountPrice *this.$store.state.rate).toFixed(2) }}

                                        {{ this.$store.state.UnitPrice }}</p>
                                </div>

                                <div  v-if="this.selectDeliveryType == 5 &&deliveryPrice>0"
                                 class="p-3 flex justify-between
                                  items-center border
                                   border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-slate-800
                                  text-red-600">
                                    <div>
                                        <h5 class="font-semibold">{{$t('Shipping')}}</h5>
                                        <p class="text-sm text-red-600">
                                        </p>
                                    </div>
                                    <div v-if="$store.state.tax>0">
                                        <h5 class="font-semibold">{{$t('tax')}} 
                                          ( {{ $store.state.tax }}% )</h5>
                                        <p class="text-sm text-green-600">
                                          +{{
                ((
                  (this.$store.state.tax *
                    (this.PartialPrice -
                      (this.discountPrice * this.PartialPrice) / 100 +
                      this.deliveryPrice)) /
                  100
                )*this.$store.state.rate).toFixed(2)
              }} {{ this.$store.state.UnitPrice }}
                                        </p>
                                    </div>
                                    <div>
                                      <h5 class="font-semibold"></h5>
                                    <p class="text-red-600 font-semibold">

                                      +{{ (deliveryPrice*this.$store.state.rate).toFixed(2) }} 
                                        {{this.$store.state.UnitPrice }}</p>
                                    </div>
                                </div>
<!-- fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff -->
<div  v-if="$store.state.tax>0"
                                 class="p-3 flex justify-between
                                  items-center border
                                   border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-slate-800
                                  text-red-600">
                                   
                                    <div >
                                        <h5 class="font-semibold">{{$t('tax')}} 
                                          ( {{ $store.state.tax }}% )</h5>
                                        <p class="text-sm text-green-600">
                                          +( {{ $store.state.tax }}% )
                                        </p>
                                    </div>
                                    
                                </div>
                                <!-- ffffffffffffffffffffffffffffff -->

                                <div class="p-3 flex justify-between items-center border border-gray-100 dark:border-gray-800">
                                    <div>
                                        <h5 class="font-semibold">{{$t('total')}} </h5>
                                    </div>

                                    <p class="font-semibold">{{ (totalPrice*this.$store.state.rate).toFixed(2) }} {{ this.$store.state.UnitPrice }}</p>
                                </div>
                            </div>

                            <div class="subcribe-form mt-6">
                                <div class="relative max-w-xl" 
                                >
                                    <input 
                                    type="text"
                                     id="subcribe"
                                      name="discount"
                                       class="py-4 pe-40 
                                       ps-6 w-full h-[50px] 
                                       outline-none text-black 
                                       dark:text-white rounded-full
                                        bg-white dark:bg-slate-900 
                                        shadow dark:shadow-gray-800" 
                                        v-model="disCode"
                                        :placeholder="$t('Couponcode')">
                                    <button 
                                     class="py-2 px-4 inline-block 
                                     font-semibold tracking-wide 
                                     align-middle duration-500 
                                     text-base text-center absolute 
                                     top-[2px] end-[3px] h-[46px] 
                                     bg-orange-500 text-white rounded-full apply_coupon"
                                     
                                     @click="Couponcode()"

                                     >{{$t('Applay coupon')}}</button>
                                     <span style="color:red">{{ couponMsg }}</span>
                                </div><!--end form-->
                            </div>
                        </div>
                    </div><!--end col-->
                </div><!--end grid-->
            </div><!--end container-->

        </section><!--end section-->

        <div v-else>
 <div class="container">
          <h4
            style="text-align: center; text-decoration: 2px underline; text-underline-offset: 3px; margin-top:1%;"
          >{{ $t('cartEmpty')}} !!</h4>
          <a
      style="text-align: center; text-decoration: 2px underline; text-underline-offset: 3px; 
      margin-top:1%;
      cursor:pointer;
      "
        
        @click="$router.push({
              name: 'home',
              params: { storeName: $store.storeName,lang:$store.state.routeLang },
            })
            "
      >{{ $t("Continueshopping") }}</a>
    
      <img
        v-if="this.items.length == 0"
        style="width: 50%; margin-left: 25%; margin-right: 25%;    
         filter: grayscale(0.85);"
        src="/assets/image/emptyCard.gif"
      />

      
       </div>
                          </div>
                  
        <!-- End -->
<vodal
  :show="showConfirmPopup"
  animation="flip"
  :width="600"
  :height="520"
  @hide="showConfirmPopup = false"
  class="pop_social"
>

  <div class="p-6">


    <!-- LOGO -->
    <div class="flex justify-center mb-5">

      <img
        v-if="DBitemsFooter && DBitemsFooter.market.logo_footer"
        :src="DBitemsFooter.market.logo_footer"
        alt="logo"
        class="h-24 object-contain pop_image"
      />

    </div>



    <!-- TITLE -->
    <h3 class="text-xl font-semibold text-center mb-4">
      {{ $t("contactUs") }}
    </h3>



    <p class="text-center mb-6">
      {{ $t("You can follow us on our social media accounts before completing your order.") }}
    </p>



    <!-- SOCIAL ICONS -->
    <ul class="list-none flex justify-center gap-3 flex-wrap">



      <!-- Facebook -->
      <li v-if="DBitemsFooter && DBitemsFooter.social.facebook">

        <a
          :href="DBitemsFooter.social.facebook"
          target="_blank"
          class="size-10 inline-flex items-center justify-center border rounded-md hover:text-orange-500"
        >

          <i
            v-html="facebook"
            class="h-4 w-4">
          </i>

        </a>

      </li>




      <!-- Discord -->
      <li v-if="DBitemsFooter && DBitemsFooter.social.discord">

        <a
          :href="DBitemsFooter.social.discord"
          target="_blank"
          class="size-10 inline-flex items-center justify-center border rounded-md hover:text-orange-500"
        >

          <i class="bi bi-discord"></i>

        </a>

      </li>




      <!-- Instagram -->
      <li v-if="DBitemsFooter && DBitemsFooter.social.instgram">

        <a
          :href="DBitemsFooter.social.instgram"
          target="_blank"
          class="size-10 inline-flex items-center justify-center border rounded-md hover:text-orange-500"
        >

                    <i class="mdi mdi-instagram"></i>


        </a>

      </li>





      <!-- Twitter -->
      <li v-if="DBitemsFooter && DBitemsFooter.social.twitter">

        <a
          :href="DBitemsFooter.social.twitter"
          target="_blank"
          class="size-10 inline-flex items-center justify-center border rounded-md hover:text-orange-500"
        >

          <i
            v-html="twitter">
          </i>

        </a>

      </li>






      <!-- Whatsapp -->
      <li v-if="DBitemsFooter && DBitemsFooter.social.whatsapp">

        <a
          :href="DBitemsFooter.social.whatsapp"
          target="_blank"
          class="size-10 inline-flex items-center justify-center border rounded-md hover:text-orange-500"
        >

          <i class="mdi mdi-whatsapp text-lg"></i>

        </a>

      </li>







      <!-- TikTok -->
      <li v-if="DBitemsFooter && DBitemsFooter.social.tiktok">

        <a
          :href="DBitemsFooter.social.tiktok"
          target="_blank"
          class="size-10 inline-flex items-center justify-center border rounded-md hover:text-orange-500"
        >

 <i class="bi bi-tiktok"></i>
        


        </a>

      </li>






      <!-- Snapchat -->
      <li v-if="DBitemsFooter && DBitemsFooter.social.snapchat">

        <a
          :href="DBitemsFooter.social.snapchat"
          target="_blank"
          class="size-10 inline-flex items-center justify-center border rounded-md hover:text-orange-500"
        >

          <i class="mdi mdi-snapchat"></i>

        </a>

      </li>



    </ul>





    <!-- BUTTONS -->
    <div class="mt-8 flex justify-center gap-4">


      <button
        class="py-2 px-6 bg-gray-500 text-white rounded-md"
        @click="showConfirmPopup=false"
      >

        {{ $t("cancel") }}

      </button>





      <button
        class="py-2 px-6 bg-orange-500 text-white rounded-md"
        @click="submitOrder"
      >

        {{ $t("Confirm Order") }}

      </button>


    </div>



  </div>


</vodal>
</div>
</template>

    
<script>
import AddAddress from "../components/AddAddress.vue";
import cart_item from "../components/item_cart_order.vue";

import Vodal from "vodal";
import "vodal/common.css";
import "vodal/slide-down.css";
import "vodal/flip.css";


export default {
  components: {
    Vodal,
    AddAddress,
    cart_item
  },
  data: function () {
    return {
      loading:false,
      showConfirmPopup: false,
      couponType: 'percentage',
        name:null,
        phone:null,
        email:null,
      items: [],
      products: [],
      products_cost: [],
      loadingMethods: false,
      addresses: [],
      addAddress: false,
      showAddress: false,
      showMonthes: false,
      DBitems: null,
      discount_delivery_free	:0,
      selectPaymentType: null,
      selectDeliveryType: null,
      selectAddress: null,
      count_month: null,
      disCode: null,
      discount_id: null,
      PartialPrice: 0,
      discountPrice: 0,
      deliveryPrice: 0,
      totalPrice: 0,
      couponMsg: "",
      unit: this.$store.state.unit,
      allOrderNote: "",
      langChange:"",
       gift: {
        is_gift: 0,
        sender: "",
        receiver: "",
        message: "",
        phone: null
      },
      is_delivery_later: 0,
      is_delivery_now: 0,
      minTime:"00.00",
      maxTime:"24.00",
      delivery_time:null,
      delivery_date:null,
      DBitemsFooter:null
    };
  },
  created() {
    this.$store.state.topbar='topbar_light';
   this.$store.state.navbar='navbar_dark';
    if(this.$i18n.locale == 'ar')
    {
        this.unit=this.$store.state.unitAR;
    }
    else
    {
      this.unit=this.$store.state.unit;
    }
    this.axios
      .get(this.$store.state.base_api_url + this.$store.storeName + "/footer_theme8",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        })
      .then((response) => (this.DBitemsFooter = response.data.data
        //  this.i=response.data.data.sections/2
      ))
      .then(() => (this.loading = false));
    //get profile

    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/profile",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName)
          }
        }
      )
      .then(response => {
        this.email = response.data.data.email;
        this.name = response.data.data.name;
        this.phone=response.data.data.phone;
        console.log('phone ' +this.phone);
      })
    //
    let AllCookies = this.$cookies.keys();
    this.items = [];
    this.products = [];
    this.products_cost=[];
    for (let i = 0; i < AllCookies.length; i++) {
      if (AllCookies[i].split("/")[0] == this.$store.storeName) {
        console.log('$$$$$$ ')

        this.items.push(AllCookies[i]);
        this.products.push(this.$cookies.get(AllCookies[i]));
        ////PartialPrice
        if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
          this.PartialPrice += this.$cookies.get(AllCookies[i]).offer_price;

          console.log('$$$$$$ offer price ',i,'  ',this.PartialPrice)
        } else {
          
          this.PartialPrice += this.$cookies.get(AllCookies[i]).total_price;
          console.log('$$$$$$  total_price ',i,' ',this.PartialPrice)
        }
        // console.log('products',pluck(this.products,"product_id"));
      }
    }
    for (let i = 0; i < this.products.length; i++) {
      this.products_cost.push(this.products[i]['product_id']);
    }
    console.log('product_cost: ',this.products_cost);

    ///////////addresses
    this.loading = true;
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/addresses",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName),
          },
        }
      )
      .then((response) => {
        this.addresses = response.data.data.addresses.addresses;
       
      })
      .then((this.loading = false))
      .catch((error) => {
        if (error.response.status == "401") {
          this.$localStorage.remove(this.$store.storeName);
          window.location.href = "/" ;
        }
      });
    ///////////methods
    this.loadingMethods = true;
    this.axios
      .get(
        this.$store.state.base_api_url +
          this.$store.storeName +
          "/order/create",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName),
          },
        }
      )
      .then((response) => {
        this.DBitems = response.data.data;
        // console.log(this.addresses);
      })
      .then((this.loadingMethods = false))
      .catch((error) => {
        if (error.response.status == "401") {
          this.$localStorage.remove(this.$store.storeName);
          window.location.href="/";
        }
      });

      //  this.selectDeliveryTypeId(5)
        // this.open_address();
  },
  watch: {
    langChange(){
      this.loading=false;
      if(this.$i18n.locale == 'ar')
    {
        this.unit=this.$store.state.unitAR;
    }
    else
    {
      this.unit=this.$store.state.unit;
    }
    //get profile

    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/profile",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName)
          }
        }
      )
      .then(response => {
        this.email = response.data.data.email;
        this.name = response.data.data.name;
        this.phone=response.data.data.phone;
        console.log('phone ' +this.phone);
      })
    //
    let AllCookies = this.$cookies.keys();
    this.items = [];
    this.products = [];
    this.products_cost=[];
    this.PartialPrice=0;
    for (let i = 0; i < AllCookies.length; i++) {
      if (AllCookies[i].split("/")[0] == this.$store.storeName) {
        this.items.push(AllCookies[i]);
        this.products.push(this.$cookies.get(AllCookies[i]));
        ////PartialPrice
        if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
          this.PartialPrice += this.$cookies.get(AllCookies[i]).offer_price;
          console.log('fff')
        } else {
          this.PartialPrice += this.$cookies.get(AllCookies[i]).total_price;
          console.log('fff2')
        }
        // console.log('products',pluck(this.products,"product_id"));
      }
    }

    for (let i = 0; i < this.products.length; i++) {
      this.products_cost.push(this.products[i]['product_id']);
    }
    console.log('product_cost: ',this.products_cost);

    ///////////addresses
    this.loading = true;
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/addresses",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName),
          },
        }
      )
      .then((response) => {
        this.addresses = response.data.data.addresses.addresses;
        ////selectAddress
        /*if (this.addresses.length != 0) {
          this.selectAddress = this.addresses[0].id;
        }*/
        // console.log(this.addresses);
      })
      .then((this.loading = false))
      .catch((error) => {
        if (error.response.status == "401") {
          this.$localStorage.remove(this.$store.storeName);
          window.location.href = "/" ;
        }
      });
    ///////////methods
    this.loadingMethods = true;
    this.axios
      .get(
        this.$store.state.base_api_url +
          this.$store.storeName +
          "/order/create",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName),
          },
        }
      )
      .then((response) => {
        this.DBitems = response.data.data;
        // console.log(this.addresses);
      })
      .then((this.loadingMethods = false))
      .catch((error) => {
        if (error.response.status == "401") {
          this.$localStorage.remove(this.$store.storeName);
          window.location.href="/";
        }
      });
    }
   ,
    PartialPrice() {
      //$store.state.tax
      //console.log("this.$store.state.tax "+ this.$store.state.tax + "  " +this.$store.state.tax+  this.PartialPrice)
        if(this.couponType=='fixed'){
      let x =
        this.PartialPrice -
        (this.discountPrice ) +
        this.deliveryPrice;
      this.totalPrice = x + (this.$store.state.tax * x) / 100;}
      else{
        let x =
        this.PartialPrice -
        (this.discountPrice * this.PartialPrice) / 100 +
        this.deliveryPrice;
      this.totalPrice = x + (this.$store.state.tax * x) / 100;}
      /*  let x= this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 );
            this.totalPrice = x + ( (this.$store.state.tax *  x) / 100 ) +this.deliveryPrice;*/
      /* this.totalPrice =
               this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 )+ this.deliveryPrice;
             console.log("PartialPrice Change" + this.totalPrice);*/
             if( this.totalPrice<0){this.totalPrice=0;}
    },
    discountPrice() {
      if(this.couponType=='fixed'){
      let x =
        this.PartialPrice -
        (this.discountPrice ) +
        this.deliveryPrice;
      this.totalPrice = x + (this.$store.state.tax * x) / 100;}
      else{
        let x =
        this.PartialPrice -
        (this.discountPrice * this.PartialPrice) / 100 +
        this.deliveryPrice;
      this.totalPrice = x + (this.$store.state.tax * x) / 100;}
      /* this.totalPrice =
             this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 )+ this.deliveryPrice;
             console.log("discountPrice Change" + this.totalPrice);*/
    },
    deliveryPrice() {
       if(this.couponType=='fixed'){
      let x =
        this.PartialPrice -
        (this.discountPrice ) +
        this.deliveryPrice;
      this.totalPrice = x + (this.$store.state.tax * x) / 100;}
      else{
        let x =
        this.PartialPrice -
        (this.discountPrice * this.PartialPrice) / 100 +
        this.deliveryPrice;
      this.totalPrice = x + (this.$store.state.tax * x) / 100;}
      /*  this.totalPrice =
              this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 )+ this.deliveryPrice;
              console.log("deliveryPrice Change" + this.totalPrice);*/
    },
    selectDeliveryType() {
      if (this.selectDeliveryType == 5) {
        this.showAddress = true;
        //console.log("this.showAddress" + this.showAddress);
      } else {
        this.showAddress = false;
        this.deliveryPrice=0;

      }
    },
    selectPaymentType() {
      if (this.selectPaymentType == 4) {
        this.showMonthes = true;
      } else {
        this.showMonthes = false;
        this.count_month = null;
      }
      //console.log( this.count_month)
    },
    addAddress() {
      this.selectDeliveryTypeId(5);
    },

  
  },
  updated() {
    this.langChange=this.$i18n.locale
  },
  methods: {
      checkClosedDays() {
    console.log('hhhhhhhhhhhh',this.delivery_date)
  if (!this.delivery_date || !this.DBitems.days) return
    console.log('sssssssssssssssss')

  const dayMap = {
    sun: 0,
    mon: 1,
    tue: 2,
    wed: 3,
    thu: 4,
    fri: 5,
    sat: 6
  }

  const selectedDate = new Date(this.delivery_date)
  const selectedDayNumber = selectedDate.getDay()

  // البحث عن إعدادات اليوم
  const dayConfig = this.DBitems.days.find(
    d => dayMap[d.day] === selectedDayNumber
  )

  if (!dayConfig) return

  // ❌ اليوم مغلق
  if (dayConfig.is_closed === "1") {
    alert('عذراً، هذا اليوم مغلق. الرجاء اختيار يوم آخر')
    this.delivery_date = null
    this.delivery_time = null
    this.minTime = null
    this.maxTime = null
    return
  }

  // ⏰ ضبط وقت البداية والنهاية (هذا هو المطلوب)
  this.minTime = dayConfig.start_time
  this.maxTime = dayConfig.end_time

  // إعادة تعيين الوقت إذا كان خارج النطاق
  if (
    this.delivery_time &&
    (this.delivery_time < this.minTime ||
     this.delivery_time > this.maxTime)
  ) {
    this.delivery_time = null
  }
},
     funIsGift() {
      if (this.gift.is_gift == 0) {
        this.gift.is_gift = 1;
        this.selectDeliveryTypeId(5)
        this.open_address();
      }
      else {
        this.gift.is_gift = 0;
        this.close_address();
      }
    },
    close_address()
    {
      this.$store.state.addAddress=false;
    },
    open_address(){
      this.$store.state.addAddress = true;},
    updatAddress() {
      ///////////addresses
      this.loading = true;
      this.axios
        .get(
          this.$store.state.base_api_url + this.$store.storeName + "/addresses",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName),
            },
          }
        )
        .then((response) => {
          this.addresses = response.data.data.addresses.addresses;
          /*if (this.addresses.length != 0) {
            this.selectAddress = this.addresses[0].id;
          }*/
          // console.log(this.addresses);
        })
        .then((this.loading = false))
        .catch((error) => {
          if (error.response.status == "401") {
            this.$localStorage.remove(this.$store.storeName);
            window.location.href =
              "/";
          }
        });
    },
    updatedata2() {
      console.log('jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj')
      this.langChange_check=false;
      this.langChange=false;
      ///////////methods
    this.loadingMethods = true;
    this.axios
      .get(
        this.$store.state.base_api_url +
          this.$store.storeName +
          "/order/create",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName),
          },
        }
      )
      .then((response) => {
        this.DBitems = response.data.data;
        // console.log(this.addresses);
      })
      .then((this.loadingMethods = false))
      .catch((error) => {
        if (error.response.status == "401") {
          this.$localStorage.remove(this.$store.storeName);
          window.location.href="/";
        }
      });

    },
    Couponcode() {
      this.loading = true;
      this.axios
        .post(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/use_coupon",
          {
            code: this.disCode,
            total_price: this.PartialPrice,
            products: this.products_cost

          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName),
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            this.couponMsg = "";
            this.discountPrice = response.data.data.discount;
            this.discount_id = response.data.data.discount_id;
            this.discount_delivery_free=response.data.data.isdelivery_free;
            this.couponType=response.data.data.type;
            if(this.discount_delivery_free==1)
            this.deliveryPrice=0;
            /////////for select
           // this.selectAddress = null;
            // this.deliveryPrice = 0;
            ////////////
          } else {
            this.couponMsg = response.data.message;
            /////////for select
           // this.selectAddress = null;
           // this.deliveryPrice = 0;
            ////////////
          }
          //this.addresses = response.data.data.addresses.addresses;
          // console.log(this.addresses);
        })
        .then((this.loading = false))
        .catch((error) => {
          if (error.response.status == "401") {
            this.$localStorage.remove(this.$store.storeName);
            window.location.href =
              "/" ;
          }
        });
    },
    selectPaymentTypeId(id) {
      this.loadingMethods = true;
      this.selectPaymentType = id;
      //console.log(this.selectPaymentType);

      for (let el = 0; el < this.DBitems.payment_types.types.length; el++) {
        this.DBitems.payment_types.types[el].isActive = false;
        if (this.DBitems.payment_types.types[el].id == id) {
          this.DBitems.payment_types.types[el].isActive = true;
        }
        //console.log(this.DBitems.payment_types.types[el].isActive);
      }

      //setTimeout(() => {
      this.loadingMethods = false;
      //  }, 3000);
    },
    selectDeliveryTypeId(id) {
      this.loadingMethods = true;
      this.axios
        .post(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/cost_delivery",
          {
            address_id: this.selectAddress,
            delivery_id: id,
            cost:this.PartialPrice,
            products:this.products_cost,
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName),
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            if(this.discount_delivery_free==0){
              // console.log(this.discount_delivery_free);
            this.deliveryPrice = response.data.data.cost;
            }
            this.selectDeliveryType = id;
            //console.log(this.selectDeliveryType);
            for (
              let el = 0;
              el < this.DBitems.delivery_type.types.length;
              el++
            ) {
              this.DBitems.delivery_type.types[el].isActive = false;
              if (this.DBitems.delivery_type.types[el].id == id) {
                this.DBitems.delivery_type.types[el].isActive = true;
              }
              //console.log(this.DBitems.delivery_type.types[el].isActive);
            }
            // this.discountPrice = response.data.data.discount;
          } else {
            alert(response.data.message);
            this.selectAddress = null;

            const $select = document.querySelector("#addressSelect");
            $select.value = "SelectOne";
          }
          //this.addresses = response.data.data.addresses.addresses;
          // console.log(this.addresses);
        })
        .then(() => {
          this.loadingMethods = false;
        })
        .catch((error) => {
          if (error.response.status == "401") {
            this.$localStorage.remove(this.$store.storeName);
            window.location.href =
              "/";
          }
        });
    },
    onChange: function (event) {
      this.selectAddress = event.target.value;
      this.selectDeliveryTypeId(5);
    },
    onChangeMonths: function (event) {
      //console.log( event.target.value)
      this.count_month = event.target.value;
    },
    openConfirmPopup(){

    if(this.selectPaymentType==null){

        if(this.$i18n.locale=="ar"){
            alert("يجب تحديد طريقة الدفع");
        }else{
            alert("Please select payment method");
        }

        return;
    }

    if(this.selectDeliveryType==null){

        if(this.$i18n.locale=="ar"){
            alert("يجب تحديد طريقة التوصيل");
        }else{
            alert("Please select delivery method");
        }

        return;
    }

    this.showConfirmPopup=true;

},
submitOrder(){

    this.showConfirmPopup=false;

    this.confirmOrder();

},
    confirmOrder() {
      document.getElementById("confirm_btn").disabled = true;

      if (this.selectPaymentType == null) {

        if (this.$i18n.locale == "ar") {
          alert("يجب تحديد طريقة الدفع");
        } else {
          alert("Please select a payment type");
        }
      } 
      if (this.selectDeliveryType == null) {
        if (this.$i18n.locale == "ar") {
          alert("يجب تحديد طريقة التوصيل");
        } else {
          alert("Please select a delivery type");
        }
      } 
      if (this.selectDeliveryType != null&&this.selectPaymentType != null)
       {
        this.loading=true;
        this.gift.phone=this.$store.state.country_code+this.gift.phone;
        this.axios
          .post(
            this.$store.state.base_api_url +
              this.$store.storeName +
              "/order/store",
            {
              address_id: this.selectAddress,
              delivery_type_id: this.selectDeliveryType,
              payment_type_id: this.selectPaymentType,
              total_price: this.totalPrice,
              discount_id: this.discount_id,
              products: this.products,
              part_price: this.PartialPrice,
              note: this.allOrderNote,
              count_month: this.count_month,
              device:'web',
               gift:this.gift,
              delivery_later:this.is_delivery_later,
              delivery_date:this.delivery_date,
              delivery_time:this.delivery_time,
            },
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
                Authorization:
                  "Bearer " + this.$localStorage.get(this.$store.storeName),
              },
            }
          )
          .then((response) => {
            if (response.data.code == "1") {
              if(response.data.data.clear_cart==null||response.data.data.link_pay == null)
              {
              for (let i = 0; i < this.items.length; i++) {
                this.$cookies.remove(this.items[i]);
              }
              this.items = [];

              console.log("hiiiiiiii" + this.$cookies.keys());
              this.$store.state.cartCounter = 0;
            }

              //console.log("hiiiiiiii" + this.$cookies.keys());

              if (response.data.data.link_pay == null) {
                this.$store.state.cartCounter = 0;
              this.$router.push({
                name: "myOrders",
                params: {
                  storeName: this.$store.storeName,
                  lang: this.$i18n.locale
                },
              });
              }
             
              if (response.data.data.link_pay != null) {
                window.location.href = response.data.data.link_pay;
              }

              //this.deliveryPrice = response.data.data.cost;
              // this.discountPrice = response.data.data.discount;
            } else {
              alert(response.data.message);
              // this.couponMsg = response.data.message;
            }
            //this.addresses = response.data.data.addresses.addresses;
            // console.log(this.addresses);
          })
          .then((this.loading = false))
          .catch((error) => {
            if (error.response.status == "401") {
              this.$localStorage.remove(this.$store.storeName);
              window.location.href =
                "/"+this.$i18n.locale ;
            }
          });
      }
    },
  },
};

</script>